import PlaceDetail from './PlaceDetail';

export default PlaceDetail;